/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { FaGlobe } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { V, DownArrow as DownArrowIcon } from "../../Constants/assets";

const InnerContainer = styled.div.attrs(props => ({
    style: props.style,
}))`
    font-size: 16px;
    background-color: white;
    border-radius: 7px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 10px 15px;
    display: flex;
    width: 13%;
    height: 45px;
    cursor: ${props => (props.isGamePaused ? 'not-allowed' : 'pointer')};

`;

const SelectedLanguage = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    column-gap: 10px;
    justify-content: space-between;
`;

const Language = styled.div`
    display: flex;
    align-items: center;
    column-gap: 10px;
`;

const DropDown = styled.div`
    position: absolute;
    top: 50px;
    right: 0;
    background-color: white;
    border-radius: 7px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
    z-index: 1000;
`;

const LanguageOption = styled.div`
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    &:hover {
        background-color: #f1f1f1;
    }
    &:not(:last-child) {
        border-bottom: inset;
    }
`;

const DownArrow = styled(DownArrowIcon)`
    transition: transform 0.3s ease;
    ${({ open }) =>
        open &&
        css`
            transform: rotate(180deg);
        `}
`;

// TODO: Fix this, this is temporary fix
const languageSelector = ({ style,
    languages,
    isGamePaused = false,
    currentLanguage,
    setCurrentLanguage,
    shortCutLanguage,
}) => {
    const { t } = useTranslation();

    const [openDropDown, setOpenDropDown] = useState(false);
    const [defaultShortLanguage, setDefaultShortLanguage] = useState('en');

    const handleClick = () => {
        if (!isGamePaused) {
            setOpenDropDown(!openDropDown);
        }
    };
    return (
        <InnerContainer isGamePaused={isGamePaused} style={style} onClick={() => handleClick()}>
            <SelectedLanguage>
                <Language>
                    <FaGlobe />
                    {currentLanguage}
                </Language>
                <DownArrow open={openDropDown} />
            </SelectedLanguage>
            {openDropDown && (
                <DropDown>
                    {languages.map((language, index) => {
                        return (
                            <LanguageOption
                                key={index}
                                value={language}
                                onClick={() => {
                                    setCurrentLanguage(t(`global_variables.language.language.${language}`), language);
                                    i18n.changeLanguage(language);
                                }}
                            >
                                {t(`global_variables.language.language.${language}`)}
                                {shortCutLanguage == t(`global_variables.language.shortcuts.${language}`) && (
                                    <V />
                                )}
                            </LanguageOption>
                        );
                    })}
                </DropDown>
            )}
        </InnerContainer>
    );
};

export default React.memo(languageSelector);
